import { useCallback, useEffect, useMemo, useReducer, useState } from "react"
import DropZone from "../../../drag-drop-template/drop-zone"
import PickUp from "../../../drag-drop-template/pick-up"
//@ts-ignore
import { Preview } from 'react-dnd-preview'
import Sticky from 'react-sticky-el';

type Props = {
    onComplete(): void
}

type Author = {
    id: string,
    name: string,
    correct: string,
    answer?: Quote
}

type Quote = {
    id: string,
    text: string
}

type GameState = {
    authors: Author[],
    freeQuotes: Quote[]
}

const DATA = [
    ['Książki są lekarstwem dla umysłu.', 'Demokryt'],
    ['Biblioteka to skarbnica lekarstw duszy.', 'Ozymandias (napis w bibliotece w Tebach)'],
    ['Czytanie książek to najpiękniejsza zabawa, jaką sobie ludzkość wymyśliła', 'Wisława Szymborska'],
    ['Książka, myśl, słowo, uczucie, czyn... Wszystko razem stanowi dopiero człowieka.', 'Józef Ignacy Kraszewski'],
    ['Ludzie przestają myśleć, gdy przestają czytać', 'Denis Diderot'],
    ['Gdy ktoś czyta, zawsze albo się czegoś nauczy, albo zapomni o tym co mu dolega, albo zaśnie - w każdym razie - wygra.', 'Henryk Sienkiewicz'],
    ['Ten, kto chce pozostać w dobrym zdrowiu, powinien unikać smutnych nastrojów i zachowywać radosny umysł.', 'Leonardo da Vinci'],
    ['Szlachetne zdrowie,<br />Nikt się nie dowie,<br />Jako smakujesz,<br />Aż się zepsujesz.', 'Jan Kochanowski']
]

const Task106Game: React.FC<Props> = ({ onComplete }) => {

    const [gameState, moveQuote] = useReducer((state: GameState, { qId, aId }: { qId: string, aId: string }) => {
        const quote = state.freeQuotes.find(q => q.id === qId);
        const author = state.authors.find(a => a.id === aId);

        if (author && quote && author.correct === quote.id) {
            return {
                authors: [
                    ...state.authors.map(a => {
                        if (a.id === author.id) {
                            return {
                                ...a,
                                answer: quote
                            }
                        }
                        return a;
                    })
                ],
                freeQuotes: state.freeQuotes.filter(q => q.id !== qId)
            }
        }

        return state;
    }, {
        authors: DATA.map(([q, a], index) => {
            return {
                id: `a${index}`,
                name: a,
                correct: `q${index}`
            }
        }),
        freeQuotes: DATA.map(([q, a], index) => {
            return {
                id: `q${index}`,
                text: q
            }
        }).sort(_ => Math.random() - .5)
    });

    const [error, setError] = useState('');

    useEffect(() => {
        if (error) {
            const id = setTimeout(() => {
                setError('');
            }, 1000);

            return () => {
                clearTimeout(id)
            }
        }

    }, [error, setError]);

    useEffect(() => {
        if (gameState.freeQuotes.length === 0) {
            onComplete();
        }
    }, [gameState, onComplete]);

    const onDrop = useCallback((pickupId: string, dropId: string) => {
        const quote = gameState.freeQuotes.find(q => q.id === pickupId);
        const author = gameState.authors.find(a => a.id === dropId);

        if (author && quote && author.correct === quote.id) {
            moveQuote({
                qId: pickupId,
                aId: dropId
            })
        } else {
            setError(dropId);
        }

    }, [moveQuote, gameState, setError]);

    const quote = useMemo(() => {
        return gameState.freeQuotes[0];
    }, [gameState]);

    return <div className="game">
        <div className="authors">
            {
                gameState.authors.map(author => {
                    return <div className="author" key={author.id}>
                        <p className='name'>{author.name}</p>
                        <div className={`answer ${error === author.id ? 'error' : ''}`}>
                            {!author.answer && <DropZone id={author.id} targetType='item' onDrop={onDrop}>
                                Przeciągnij poprawny cytat tutaj
                            </DropZone>}
                            {author.answer && <GameItem item={author.answer} />}
                        </div>
                    </div>
                })
            }
        </div>
        <div className="quotes">
            {quote && <Sticky>
                <div className="quote" key={quote.id}>
                    <PickUp data={{ type: 'item', id: quote.id, data: quote }}>
                        <GameItem item={quote} />
                    </PickUp>
                </div>
            </Sticky>}
        </div>

        <ItemPreview />
    </div>
}

const GameItem: React.FC<{ item: Quote }> = ({ item: data }) => {
    return <div className="quote-item task-106-pick-up">
        <div className="inner" dangerouslySetInnerHTML={{ __html: data.text }}></div>
    </div>
}

const ItemPreview: React.FC<{}> = () => {
    return <Preview>{({ item, style }: any) => {
        return <div style={{ ...style, width: item.size.width }}>
            <GameItem item={item.data} />
        </div>
    }}</Preview>
}

export default Task106Game;
